export type Campus = {
  _id: string;
  name: string;
  address: string;
  phone: string;
  logo: string;
};

// Metropolitan Academy's 5 public campuses. Deliberately hardcoded, not
// fetched from an API — this list is small and rarely changes, and every
// other lookup (sessions/systems/classes) already scopes correctly off
// whichever branch id is selected here, so a live endpoint would add a
// network round-trip for no real benefit. Campus 6 (The Eon Academy) is a
// separate, private project — never listed here, on purpose.
//
// Address/phone copied from each campus's own Branch record (mpa-api) —
// real data, not placeholders.
//
// `logo`: most campuses share the one generic Metropolitan Academy crest
// (mpa-logo.png, also the default shown before any campus is picked) —
// confirmed byte-identical across Naseerabad/North Nazimabad/O-Level Campus
// in mpa-admin's asset set. Ancholi and MPA Girls College each have their
// own genuinely distinct logo.
export const campuses: Campus[] = [
  {
    _id: "6a49351b7cd4f4a81df46a22",
    name: "Naseerabad",
    address: "B-33, Block 13, Federal B. Area, Karachi, Pk.",
    phone: "(021)36363629",
    logo: "/mpa-logo.png",
  },
  {
    _id: "6a49351c7cd4f4a81df46a23",
    name: "Ancholi",
    address: "C-10, Block 20, Federal B. Area, Karachi, Pk.",
    phone: "(021)36344548",
    logo: "/campus-ancholi-logo.png",
  },
  {
    _id: "6a49351c7cd4f4a81df46a24",
    name: "North Nazimabad",
    address: "D 31, Block B, North Nazimabad, Karachi, Pk.",
    phone: "(021)36670852",
    logo: "/mpa-logo.png",
  },
  {
    _id: "6a49351c7cd4f4a81df46a25",
    name: "O-Level Campus (Federal B Area)",
    address: "C-3 Block 13, Federal B Area, Karachi.",
    phone: "(021)36800252",
    logo: "/mpa-logo.png",
  },
  {
    _id: "6a49351c7cd4f4a81df46a26",
    name: "MPA Girls College",
    address: "C-9, Block 20, Federal B. Area, Karachi, Pk.",
    phone: "(021)36344548",
    logo: "/campus-girls-college-logo.png",
  },
];
